import { useContext, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useSnackbar } from "notistack";

import { completeUserDailyMission, getUserDailyMission } from "pages/employee-journey/employeeJourneyApi";

import { DailyMissionPIN } from "user-dashboard/components/header/Header";

import { getErrorMessage } from "utils/errorUtils";

import { UserDailyMissionContext, UserDailyMission } from "../user-daily-mission";
import { UserLevelContext } from "../user-level";

export const UserDailyMissionProvider = ({ children }) => {
	const { enqueueSnackbar } = useSnackbar();
	const intl = useIntl();

	const { fetchUserLevel } = useContext(UserLevelContext);
	const [loading, setLoading] = useState(false);
	const [openReader, setOpenReader] = useState(false);
	const [openPIN, setOpenPIN] = useState(false);
	const [userDailyMission, setUserDailyMission] = useState<UserDailyMission | undefined>();

	const completeMission = async (values: DailyMissionPIN) => {
		setLoading(true);
		setOpenReader(false);
		try {
			const res = await completeUserDailyMission(`${userDailyMission?.["_id"]}`, values.pin);
			if (res?.message === "Success") {
				setUserDailyMission(res.data);
				setOpenPIN(false);
				enqueueSnackbar(
					intl.formatMessage({
						id: "DASHBOARD.employee-journey.daily-mission.accomplished",
					}) + "!",
					{
						variant: "success",
					},
				);
				setTimeout(async () => {
					await fetchUserLevel();
				}, 300);
			}
		} catch (error) {
			let message = intl.formatMessage({
				id: "DASHBOARD.employee-journey.create_error",
			});
			const errorJson = (error as any).json;
			if (errorJson?.code) {
				message = getErrorMessage(errorJson.code);
			}
			enqueueSnackbar(message, {
				variant: "error",
			});
		} finally {
			setLoading(false);
			setOpenReader(false);
		}
	};

	useEffect(() => {
		const getCurrentMission = async () => {
			setLoading(true);
			try {
				const res = await getUserDailyMission();
				if (res?.message === "Success") {
					setUserDailyMission(res.data);
				}
			} catch (error) {
			} finally {
				setLoading(false);
			}
		};
		getCurrentMission();
	}, []);

	const value = {
		loading,
		setLoading,
		openReader,
		setOpenReader,
		openPIN,
		setOpenPIN,
		userDailyMission,
		setUserDailyMission,
		completeMission,
	};

	return <UserDailyMissionContext.Provider value={value}>{children}</UserDailyMissionContext.Provider>;
};
